<template>
  <header class="navbar">
    <SidebarButton @toggle-sidebar="$emit('toggle-sidebar')"/>
    <router-link to="home" class="home-link">
      <img class="logo" src="../assets/pie-logo.svg">
      <span class="site-name">
        PIE API
      </span>
    </router-link>
    <div class="links">
      <NavLinks class="can-hide"
        :auth="auth"
        :authenticated="authenticated"/>
    </div>
  </header>
</template>

<script>
import SidebarButton from "./SidebarButton.vue";
import NavLinks from "./NavLinks.vue";

export default {
  props: ["auth", "authenticated"],
  components: { SidebarButton, NavLinks }
};
</script>

<style lang="stylus">
  @import './styles/config.styl'
  .navbar
    box-shadow 0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12)
    height 64px !important
    display flex
    align-items center
    padding 0.7rem 1.5rem
    line-height $navbarHeight - 1.4rem
    position relative
    a, span, img
      display inline-block
    .logo
      height $navbarHeight - 1.4rem
      min-width $navbarHeight - 1.4rem
      margin-right 0.8rem
      vertical-align top
    .site-name
      font-size 1.3rem
      font-weight 600
      color $textColor
      position relative
    .links
      font-size 0.9rem
      position absolute
      right 1.5rem
      top 0.7rem

    .home-link
      display flex
      align-items center
      width 200px
      margin-left 30px
      font-size 20px
      font-weight 500
      letter-spacing .02em
      overflow hidden
      text-overflow ellipsis
      white-space nowrap
      img
        width 32px
        height 32px
      span
        margin-left 25px

  @media (max-width: $MQMobile)
    .navbar
      padding-left 4rem
      .can-hide
        display none
</style>
